import React, { useState } from "react";
import { Head2Head } from "../models/head-2-head";
import MovieCard from "./movie-card";

type HeadToHeadProps = {
  h2h: Head2Head;
  vote: (h2hId: string, winner: number) => void;
};

export default function HeadToHead(props: HeadToHeadProps) {
  const [votedSide, setVotedSide] = useState<"left" | "right" | null>(null);
  const [isAnimating, setIsAnimating] = useState(false);

  async function handleVote(movieId: number, side: "left" | "right") {
    if (isAnimating) return;
    
    setVotedSide(side);
    setIsAnimating(true);
    
    // Wait for animation to complete before calling vote
    setTimeout(() => {
      props.vote(props.h2h.id, movieId);
      setVotedSide(null);
      setIsAnimating(false);
    }, 400);
  }

  return (
    <div className="flex flex-row justify-between gap-4 md:gap-8">
      <div 
        className={`flex flex-col h2h-side transition-all duration-500 ${
          votedSide === "left" 
            ? "scale-110 opacity-100" 
            : votedSide === "right" 
            ? "scale-90 opacity-30" 
            : ""
        }`}
        onClick={() => handleVote(props.h2h.movie1.id, "left")}
      >
        <div className="cursor-pointer transform transition-all hover:scale-105 active:scale-95 hover:drop-shadow-[0_0_25px_rgba(255,157,0,0.5)]">
          <MovieCard movie={props.h2h.movie1} side="LEFT" />
        </div>
      </div>
      
      <div className="w-0 border-r-2 border-orange-200 flex-shrink-0"></div>
      
      <div 
        className={`flex flex-col h2h-side transition-all duration-500 ${
          votedSide === "right" 
            ? "scale-110 opacity-100" 
            : votedSide === "left" 
            ? "scale-90 opacity-30" 
            : ""
        }`}
        onClick={() => handleVote(props.h2h.movie2.id, "right")}
      >
        <div className="cursor-pointer transform transition-all hover:scale-105 active:scale-95 hover:drop-shadow-[0_0_25px_rgba(255,157,0,0.5)]">
          <MovieCard movie={props.h2h.movie2} side="RIGHT" />
        </div>
      </div>
    </div>
  );
}